<template>
  <ol class="docs-steps">
    <li>Fill in your details in the generator and click <b>Copy Signature</b>.</li>
    <li>In Gmail click the <b>gear icon</b> (top right) and then <b>See all settings</b>.</li>
    <li>
      In the <b>General</b> tab scroll down to <b>Signature</b> and click <b>Create new</b>.
      Give it a name (e.g. “No. J Signature”) and click <b>Create</b>.
    </li>
    <li>Click inside the signature editor and paste (<kbd class="docs-kbd">⌘ V</kbd> / <kbd class="docs-kbd">Ctrl V</kbd>).</li>
    <li>
      Under <b>Signature defaults</b> select the new signature for both <b>For new emails use</b>
      and <b>On reply/forward use</b>.
    </li>
    <li>Scroll to the bottom of the page and click <b>Save Changes</b>.</li>
    <li>Click <b>Compose</b> to check that the signature is added to new emails.</li>
  </ol>
</template>
